import TrackerContainer from './TrackerContainer';
import { getIsNewUser, getIsExistingUserSession, getIsNewPortalCreated } from '../store/app/selectors';
import { getAuthState, getIsAuthInitialized, getIsAuthenticated } from '../store/auth/selectors';
import { isPostVerification } from '../flow-settings/settingsSelectors';
const enableTracking = store => {
  const state = store.getState();
  const isNewUser = getIsNewUser(state);
  const isNewPortal = getIsNewPortalCreated(state);
  const isExistingUserSession = getIsExistingUserSession(state);

  // To enable tracking at the beginning of the flow
  if (getIsAuthInitialized(state) && !getIsAuthenticated(state) && !isNewPortal && !TrackerContainer.isAnonymousTrackingEnabled && !TrackerContainer.identifiableTrackingEnabled) {
    TrackerContainer.setupTracking();
  }

  // To enable identifiable tracking switching to existing user
  if (!isNewUser && isExistingUserSession && !isPostVerification() && TrackerContainer.isAnonymousTrackingEnabled) {
    const authState = getAuthState(state);
    if (authState.auth) {
      TrackerContainer.switchToIdentifiableTracker(authState.auth.email);
      TrackerContainer.setProperties({
        email: authState.auth.email
      });
    }
    TrackerContainer.setProperties({
      userId: authState.userId,
      hubId: authState.portalId
    });
  }
};

/**
 * @description Middleware to setup tracking
 * - Setup initial tracking when - The user accepts the cookie banner - identifable
 * - Setup initial tracking when - The user accepts rejected/ignored the cookie banner - anonymous
 */
export const TrackingAppMiddleware = store => next => action => {
  enableTracking(store);
  return next(action);
};